import { useNavigate, useParams } from "react-router-dom";
import { ICON_SIZES } from "../../helpers/constants";
import ButtonGroup from "../ButtonGroup/ButtonGroup";
import {
  MdFirstPage,
  MdLastPage,
  MdOutlineNavigateBefore,
  MdOutlineNavigateNext,
} from "react-icons/md";
import clsx from "clsx";
import useFilteredTransactions from "../../hooks/useFilteredTransactions";
import useMobile from "../../hooks/useMobile";
import { useEffect } from "react";
import { EButtonKind } from "../Button/ButtonTypes";

interface ITransactionsNavigation {
  onChange: (data: any) => void;
}

const TransactionsNavigation: React.FC<ITransactionsNavigation> = ({
  onChange,
}) => {
  const { filteredTransactions } = useFilteredTransactions();
  const { transaction, account } = useParams();
  const { isMobile } = useMobile();

  const navigate = useNavigate();

  const getPrevAndNext = () => {
    const currentIndex = filteredTransactions?.findIndex?.(
      ({ invoice: invoiceId }: { invoice: string }) => {
        return invoiceId === transaction;
      }
    );

    let prevIndex = -1;
    let nextIndex = -1;

    if (currentIndex !== -1) {
      if (currentIndex === 0) {
        prevIndex = -1;
      } else {
        prevIndex = currentIndex - 1;
      }
    }

    if (currentIndex < filteredTransactions?.length) {
      nextIndex = currentIndex + 1;
    }

    return {
      prev: {
        transaction: filteredTransactions?.[prevIndex]?.invoice || "",
        type: filteredTransactions?.[prevIndex]?.type || "",
      },
      current: {
        transaction: filteredTransactions?.[currentIndex]?.invoice || "",
        type: filteredTransactions?.[currentIndex]?.type || "",
      },
      next: {
        transaction: filteredTransactions?.[nextIndex]?.invoice || "",
        type: filteredTransactions?.[nextIndex]?.type || "",
      },
    };
  };

  const navigationActions = () => {
    const { prev, next } = getPrevAndNext();

    const actions: Array<any> = [];

    actions.push({
      icon: <MdFirstPage size={ICON_SIZES.MD} />,
      kind: EButtonKind.NORMAL,
      onClick: () => {
        if (next?.transaction) {
          navigate(`/transaction/${account}/${next.transaction}`, {
            replace: true,
          });
        }
      },
      tooltip: "Siguiente",
      disabled: !next?.transaction,
      hide: true,
    });

    actions.push({
      icon: <MdOutlineNavigateBefore size={ICON_SIZES.MD} />,
      kind: EButtonKind.NORMAL,
      onClick: () => {
        if (prev?.transaction) {
          navigate(`/transaction/${account}/${prev.transaction}`, {
            replace: true,
          });
        }
      },
      tooltip: "Anterior",
      disabled: !prev?.transaction,
      hide: !prev?.transaction,
      className: isMobile
        ? "!min-h-[42px] !min-w-[42px] !max-h-[42px] !max-w-[42px]"
        : "",
    });

    actions.push({
      icon: <MdOutlineNavigateNext size={ICON_SIZES.MD} />,
      kind: EButtonKind.NORMAL,
      onClick: () => {
        if (next?.transaction) {
          navigate(`/transaction/${account}/${next.transaction}`, {
            replace: true,
          });
        }
      },
      tooltip: "Siguiente",
      disabled: !next?.transaction,
      hide: !next?.transaction,
      className: isMobile
        ? "!min-h-[42px] !min-w-[42px] !max-h-[42px] !max-w-[42px]"
        : "",
    });

    actions.push({
      icon: <MdLastPage size={ICON_SIZES.MD} />,
      kind: EButtonKind.NORMAL,
      onClick: () => {
        if (next?.transaction) {
          navigate(`/transaction/${account}/${next.transaction}`, {
            replace: true,
          });
        }
      },
      tooltip: "Siguiente",
      disabled: !next?.transaction,
      hide: true,
    });

    return [...actions];
  };

  useEffect(() => {
    const { prev, current, next } = getPrevAndNext();
    onChange({
      prev,
      next,
      current,
    });
  }, [getPrevAndNext]);

  if (!transaction || !filteredTransactions?.length) return <></>;

  return (
    <div className={clsx([])}>
      <ButtonGroup buttons={navigationActions()} gap={1} align="right" />
    </div>
  );
};

export default TransactionsNavigation;
